import React from "react";
import {
    Button, ButtonGroup, Container, ButtonToolbar, Jumbotron, Card, Form, Row, Col,
    Dropdown, DropdownButton, Modal
} from 'react-bootstrap';
import Calendar from 'react-calendar';
import {
    Rootcontainer,
    SearchDiv,
    MainContainer,
    RootDiv,
    RootTitle,
    RootBal,
    RootRight,
    Amt,
    MoreDetails,
    RootLeft,
    RootValue,
    CustomerStatus,
    BtnGroupRight,
    STBGroup,
    STBDetails,
    CustomerStatusDiv,
    ActivPackage,
    ChannelBox,
    ChannelName,
    ChannelPrice,
    AddPackageHeading
} from "./styled";
import "./index.css";
import { Redirect } from "react-router-dom";

import {
    MdPermIdentity,
    MdHome,
    MdFiberPin,
    MdCreditCard,
    MdRefresh,
    MdAddCircle,
    MdRemoveCircle,
    MdPowerSettingsNew,
    MdArrowBack
} from "react-icons/md";
import loadinggif from "../../assets/loding-gif.gif";
import API from "../../Api";
import logo from "../../assets/logo-3.png";
import LoadingOverlay from "react-loading-overlay";
import BounceLoader from "react-spinners/BounceLoader";
import Drawer from "react-drag-drawer";
import Undraw from "react-undraw";
import axios from 'axios';
import Date from './Date';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
export default class Report extends React.Component {
    constructor(props) {
        super(props);


        this.state = {


            lcoID: localStorage.getItem("userID"),
            lcoPassword: localStorage.getItem("userPassword"),
            domainName: localStorage.getItem("domain"),
            isloggedOut: false,
            isShowLogOutDialog: false,
            lcoBalance: "",
            lcoName: "",
            lcocode: "",
            fromYear: 0,
            fromMon: 0,
            fromDay: 0,
            toYear: 0,
            toMon: 0,
            toDay: 0,
            whichDocument: "tinvoicelco",
            isSpinnerVisible: false,
            isEmptyError: "",
            DocumentType: ["tinvoicelco", "dumpdebitlog", "disconnected", "expiry"],
            endDate:"",
            startDate:""


        };

        this.getLCO_Details();
        //this.getdata1()
        console.log("try", this.props.tableData);
    }
    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }
    componentWillMount() {
        window.removeEventListener("scroll", this.handleScroll);
    }
    calStartDate(value){
        console.log(value)
        // var d=new Date(value);
        console.log(value.getDate())
        this.setState({fromDay:value.getDate(),fromMon:value.getMonth()+1,fromYear:value.getFullYear(),startDate:value})
        //console.log(d.getDate(),d.getMonth(),d.getFullYear())
        debugger;

    }
    calEndDate(value) {
        console.log(value)
        // var d=new Date(value);
        console.log(value.getDate())
        this.setState({toDay:value.getDate(),toMon:value.getMonth()+1,toYear:value.getFullYear(),endDate:value})
        //console.log(d.getDate(),d.getMonth(),d.getFullYear())
        debugger;
    }


    getLCO_Details() {
        debugger;
        this.setState({ isSpinnerVisible: true });
        const { lcoID, lcoPassword, domainName } = this.state;
        API.getLOC_Details(lcoID, lcoPassword, "lcodetail", domainName)
            .then(response => response.json())
            .then(responsejson => {
                this.setState({
                    lcoName: responsejson.lconame,
                    lcoBalance: responsejson.balance,
                    lcocode: responsejson.lcocode
                });

            });
    }

    setCasType(e) {
        console.log("selected value", e.target.value);
        this.setState({ whichDocument: e.target.value });
    }
    getCSVFile() {
        const { fromDay, fromMon, fromYear, toDay, toMon, toYear, whichDocument, lcocode, lcoID, lcoPassword, domainName } = this.state;
        if (fromDay && fromMon && fromYear && toDay && toMon && toYear && whichDocument) {
            this.setState({ isEmptyError: "", isSpinnerVisible: true });
            console.log("data in file", fromDay, fromMon, fromYear, toDay, toMon, toYear, whichDocument, lcocode, lcoID, lcoPassword);
            console.log("url", `${this.state.domainName}/?username=${lcoID}&password=${lcoPassword}&command=${whichDocument}&lcocode=${lcocode}&d1=${fromYear}-${fromMon}-${fromDay}&d2=${toYear}-${toMon}-${toDay}`);
            axios({

                url: `${this.state.domainName}/api/reportsdownload/?username=${lcoID}&password=${lcoPassword}&command=${whichDocument}&lcocode=${lcocode}&d1=${fromYear}-${fromMon}-${fromDay}&d2=${toYear}-${toMon}-${toDay}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                console.log("data", response);
                debugger;
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${whichDocument}.xlsx`);
                link.click();
                window.URL.revokeObjectURL(url);
                this.setState({ isSpinnerVisible: false });
            }).catch((error) => {
                console.log("error", error);
                this.setState({ isSpinnerVisible: false, isEmptyError: "Unable to process !" });

            });
        } else {
            this.setState({ isEmptyError: "Please fill all field !" })
        }
    }

    logOutFunc() {
        if (this.state.isloggedOut) {
            return <Redirect to="/login" />;
        } else {
            return null;
        }
    }
    logOut() {
        localStorage.removeItem("userID");
        const username = localStorage.getItem("userID");
        if (!username) {
            this.setState({ isloggedOut: true });
        }
    }
    backTOTrandactions() {
        this.props.onMoveToTransactions();
    }

    render() {
        return (
            <Rootcontainer onScroll={e => this.handleScroll(e)}>
                <LoadingOverlay
                    className={this.state.isSpinnerVisible ? "displaySpinner" : ""}
                    overlay={true}
                    active={this.state.isSpinnerVisible}
                    spinner={
                        <img
                            src={loadinggif}
                            className="spinnerContent"
                            color="green"
                            style={{ marginLeft: 100 }}
                            alt="logo"
                        />
                    }
                ></LoadingOverlay>
                <Drawer
                    open={this.state.isShowLogOutDialog}
                    onRequestClose={this.toggle}
                    direction="left"
                >
                    <Card>
                        <Card.Body className="pl-3 pr-3">
                            <div style={{ fontSize: 15, fontWeight: "bold" }}>
                                Do you want{" "}
                                <span style={{ fontSize: "1.5em", color: "red" }}>Log out</span>{" "}
                                ?
              </div>
                            <Undraw className="undrawimg" name="monitor" />
                            <Button
                                style={{ marginLeft: 20 }}
                                className="success"
                                className="mt-3 pull-right"
                                onClick={() => {
                                    this.setState({ isShowLogOutDialog: false });
                                }}
                            >
                                Cancel
              </Button>

                            <Button
                                style={{ backgroundColor: "red" }}
                                className="danger"
                                className="mt-3 pull-right"
                                onClick={() => {
                                    // this.props.hindNodataDialog();
                                    this.logOut();
                                }}
                            >
                                OK
              </Button>
                        </Card.Body>
                    </Card>
                </Drawer>

                <div className="header-div">
                    <MdArrowBack
                        onClick={() => this.backTOTrandactions()}
                        className="back-button"
                    />
                    <h3 style={{ marginLeft: "98px" }}>Report Download</h3>
                    <img
                        src={logo}
                        style={{ float: "left", marginLeft: " -180px" }}
                        className="logo-img"
                        alt="logo"
                    />

                    <MdPowerSettingsNew
                        onClick={() => {
                            this.setState({ isShowLogOutDialog: true });
                        }}
                        value="Logout"
                        className="fontSize login"
                    />
                </div>

                <RootDiv>
                    <RootLeft>
                        <RootTitle>Name :</RootTitle>

                        <RootValue
                            style={{ cursor: "pointer" }}
                        //   onClick={() => {
                        //     this.props.onClickProfile();
                        //   }}
                        >
                            {this.state.lcoName}
                        </RootValue>
                        <div className="lcocode">
                            (<span style={{ color: "black" }}>Lco code:</span>{" "}
                            {this.state.lcocode})
            </div>
                    </RootLeft>

                    <RootRight>
                        <RootTitle>Balance :</RootTitle>

                        <RootValue>
                            {"\u20B9"} {this.state.lcoBalance}
                        </RootValue>
                    </RootRight>
                </RootDiv>
                <MainContainer>

                    <Form className="form-div" style={{ marginTop: 20 }}>
                        <h4 style={{ fontSize: 15, fontWeight: "bold", alignSelf: "center", color: "red" }}>{this.state.isEmptyError}</h4>
                        <h3>Download form</h3>

                        <Row>
                            <Col xs={12} md={4} lg={3} sm={6} >
                                <Form.Group>
                                    <Form.Label>Type <span>*</span></Form.Label>
                                    <select title="CAS List" style={{ width: "80%", display: "block" }}
                                        onChange={(e) => { this.setCasType(e) }}

                                    >
                                        {this.state.DocumentType.map((item, i) => {
                                            return (
                                                <option value={item}>{item}</option>
                                            );
                                        })}
                                    </select>
                                </Form.Group>
                            </Col>



                            <Col xs={12} md={4} lg={3} sm={6} >
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>From Date</Form.Label>
                                    <div style={{ display: "flex", justifyContent: "space-around" }}>
                                    {/* <Calendar
                                            onChange={(e) => { this.calStartDate(e) }}
                                            formatMonth={Number}
                                            value={this.state.date}


                                        /> */}
                                        <DatePicker
                                        onChange={(e) => { this.calStartDate(e) }}
                                        selected={this.state.startDate}
                                        
                                        />
                                    </div>

                                </Form.Group>

                            </Col>


                            <Col xs={12} md={4} lg={3} sm={6} >
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>To Date</Form.Label>
                                    <div style={{ display: "flex", justifyContent: "space-around" }}>
                                        {/* <Calendar
                                            onChange={(e) => { this.calEndDate(e) }}
                                            formatMonth={Number}
                                            value={this.state.date2}


                                        /> */}
                                         <DatePicker
                                            onChange={(e)=>{this.calEndDate(e)}}
                                            selected={this.state.endDate}
                                        />
                                    </div>

                                </Form.Group>

                            </Col>




                        </Row>
                        <div style={{ textAlign: "end", marginRight: 20 }}>
                            <Button
                                onClick={() => { this.getCSVFile() }}
                                style={{ textAlign: "flex-end" }}
                                variant="success"
                            >
                                Download
</Button>
                        </div>


                    </Form>


                </MainContainer>

                {this.logOutFunc()}
            </Rootcontainer>
        );
    }
}